<div class="compliance-container">
  <div class="form-section">
    <div class="form-horizontal">
      <div class="form-row textarea-row">
        <label>Customer Specific Training</label>
        <textarea
          class="form-control"
          [(ngModel)]="client.customerTraining"
          [disabled]="!isEditMode || !canEdit"
          (ngModelChange)="onFieldChange()"
          rows="4"
          placeholder="Enter any customer-specific training requirements..."
          aria-label="Customer specific training"
        ></textarea>
      </div>
    </div>
  </div>

  <div class="form-section">
    <h3 class="section-title">Products</h3>
    <div *ngIf="allProducts.length > 0" class="products-grid">
      <div *ngFor="let product of allProducts; trackBy: trackByProductId" class="product-item">
        <span class="product-label">{{ product.abbreviation || product.name }}</span>
        <div class="product-selector">
          <button
            type="button"
            class="product-badge"
            [ngClass]="{
              'product-yes': isProductSelected(product.id),
              'product-no': !isProductSelected(product.id),
              disabled: !isEditMode || !canEdit
            }"
            (click)="isEditMode && canEdit && toggleProduct(product)"
            [disabled]="!isEditMode || !canEdit"
            [attr.aria-label]="(isProductSelected(product.id) ? 'Deselect ' : 'Select ') + (product.abbreviation || product.name)"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check': isProductSelected(product.id),
                'fa-times': !isProductSelected(product.id)
              }"
            ></i>
            {{ isProductSelected(product.id) ? "Yes" : "No" }}
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="allProducts.length === 0" class="placeholder-text">Loading products...</p>
  </div>
</div>
